import React, { useState } from 'react';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';

const ImageGrid = ({ blok }) => {
  if (!blok?.imageGridItems?.length) return null;
  const gridItems = blok.imageGridItems;
  // eslint-disable-next-line
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const activeItem = gridItems[activeItemIndex];
  const images = activeItem?.gridItems;

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-28">
        <div className="container">
          <div className="flex flex-wrap justify-center -ml-5 mt-9">
            {gridItems.map((itm, i) => (
              <h4
                key={`imgGridNav${i}`}
                onClick={() => setActiveItemIndex(i)}
                className={`${activeItemIndex === i && 'font-bold '} ${
                  i < gridItems.length - 1 && 'border-r pr-5'
                } py-2 pl-5  text-17px border-grey font-heading leading-[1.015em] cursor-pointer hover:opacity-50 transition-opacity ease-in-out
                hidden md:block
                `}
              >
                {itm.title}
              </h4>
            ))}
            <div className="pl-5 md:hidden flex-auto ">
              <select className="w-full" onChange={({ target: { value } }) => setActiveItemIndex(value)}>
                {gridItems.map((itm, i) => (
                  <option key={`mobile${i}`} value={i}>
                    {itm.title}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* <div className="flex justify-center mt-20 text-center">
            <TextCard blok={activeItem.textCard[0]} />
          </div> */}

          <div className="mt-10 md:mt-16">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              <div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-11">
                  <Image blok={images[0]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-15 aspect-h-16">
                  <Image blok={images[1]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-15">
                  <Image blok={images[2]} className="object-cover w-full h-full" />
                </div>
              </div>
              <div>
                <div className="w-full mb-6 bg-light-grey aspect-w-15 aspect-h-16">
                  <Image blok={images[3]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-15">
                  <Image blok={images[4]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-11">
                  <Image blok={images[5]} className="object-cover w-full h-full" />
                </div>
              </div>
              <div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-14">
                  <Image blok={images[6]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-16 aspect-h-12">
                  <Image blok={images[7]} className="object-cover w-full h-full" />
                </div>
                <div className="w-full mb-6 bg-light-grey aspect-w-15 aspect-h-16">
                  <Image blok={images[8]} className="object-cover w-full h-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default ImageGrid;
